import { styled, Tooltip } from '@mui/material';
import { FC } from 'react';

import check from '../../../static_files/GMM-icons/GMM-icon-checkwhite.svg';
import { useLayout, useProcessedBannerStore } from '../../../studentApp/hooks';
import { bannerStore } from '../../../studentApp/stores';
import {
  POINTS_LABEL_FONT_FAMILY,
  POINTS_LABEL_SIZE,
  POINTS_NUMBER_SIZE_LANDSCAPE,
  POINTS_NUMBER_SIZE_PORTRAIT,
  POINTS_NUMBER_SIZE_MOBILE,
} from '../../constants';
import { Space } from '../util/constants';
import { TextOnCanvas } from '../util/textOnCanvas';

export const PointsTodayAndWeek: FC = () => {
  const [dailyGoal, pointsToday, pointsThisWeek] = bannerStore(state => [
    state.dailyGoal,
    state.pointsToday,
    state.pointsThisWeek,
  ]);
  const { themeColor } = useProcessedBannerStore();
  const { isLandscape, isPortrait, isMobile } = useLayout();
  const todayText = isMobile ? ['Today'] : ['Points', 'Today'];
  const weekText = isMobile ? ['Week'] : ['Points', 'This Week'];
  const dailyGoalComplete = dailyGoal > 0 && pointsToday >= dailyGoal;

  return (
    <>
      <Tooltip title={dailyGoalComplete ? 'Daily goal complete!' : ''}>
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <PointsText words={todayText} />
          <Space />
          <Space />
          <TextOnCanvas
            text={
              dailyGoal > 0 ? pointsToday + ' of ' + dailyGoal : pointsToday
            }
            fontSize={
              isLandscape
                ? POINTS_NUMBER_SIZE_LANDSCAPE
                : isPortrait
                ? POINTS_NUMBER_SIZE_PORTRAIT
                : POINTS_NUMBER_SIZE_MOBILE
            }
            bold={true}
            id="pointsToday"
            roundedRectangle={true}
            color={themeColor}
            backColor={'white'}
          />
          {dailyGoalComplete && (
            <img src={check} style={{ marginLeft: '10px', height: '22px' }} />
          )}
        </span>
      </Tooltip>
      <span style={{ width: isLandscape ? '30px' : '15px' }} />
      <PointsText words={weekText} />
      <Space />
      <TextOnCanvas
        text={pointsThisWeek}
        fontSize={
          isLandscape
            ? POINTS_NUMBER_SIZE_LANDSCAPE
            : isPortrait
            ? POINTS_NUMBER_SIZE_PORTRAIT
            : POINTS_NUMBER_SIZE_MOBILE
        }
        bold={true}
        id="pointsThisWeek"
        roundedRectangle={true}
        color={themeColor}
        backColor={'white'}
      />
    </>
  );
};

export const PointsText: FC<{ words: string[] }> = ({ words }) => {
  return (
    <StyledPointsText
      style={{
        fontSize: POINTS_LABEL_SIZE,
        fontFamily: POINTS_LABEL_FONT_FAMILY,
      }}
    >
      {words.map((word, index) => (
        <span key={index}>{word}</span>
      ))}
    </StyledPointsText>
  );
};

const StyledPointsText = styled('span')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontWeight: 'bold',
  textAlign: 'center',
  lineHeight: '1.2',
}));
